import { useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import AdminLayout from "../AdminLayout";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ChangePassword() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [saving, setSaving] = useState(false);

  const input = "w-full rounded-lg border border-slate-300 px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-red-600";

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      toast.error("New password and confirmation do not match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", form);
      toast.success("Password changed successfully. Use your new password next time.");
      setForm({ current_password: "", new_password: "", confirm_password: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout title="Change Password" testid="admin-change-password">
      <form onSubmit={submit} className="max-w-md bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-4" data-testid="change-password-form">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1">Current Password</label>
          <input type="password" required value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="current-password" className={input} />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1">New Password</label>
          <input type="password" required minLength={6} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="new-password" className={input} />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1">Confirm New Password</label>
          <input type="password" required value={form.confirm_password} onChange={(e) => setForm({ ...form, confirm_password: e.target.value })} data-testid="confirm-password" className={input} />
        </div>
        <button type="submit" disabled={saving} data-testid="change-password-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-red-600 py-2.5 font-semibold text-white hover:bg-red-700 disabled:opacity-60">
          {saving ? <Loader2 className="animate-spin" size={18} /> : null}Change Password
        </button>
      </form>
    </AdminLayout>
  );
}
